import type { BatchEnrollmentCandidateVM } from "@shared-kernel/application/ports/admin/batch-enrollment-candidate";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveBatchEnrollmentCandidateList = createApiThunk<BatchEnrollmentCandidateVM[], void>(
  "batchEnrollmentCandidates/adminRetrieveBatchEnrollmentCandidateList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listBatchEnrollmentCandidates();
  },
);
